import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';

/**
 * A service that checks if the user is logged in and redirect to the connection page if needed.
 * @param {OAuthService} oauthService - The OAuth service to use.
 * @param {Router} router - The router to use.
 * @returns None
 */
@Injectable()
export class AuthGuardService  {
    constructor(private oauthService: OAuthService, public router: Router) { }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        if(this.oauthService.hasValidAccessToken()) {
            return true;
        } else {
            this.router.navigateByUrl('/connected');
            return false;
        }
    }
}
